import axios from 'axios';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';

// Criar instância do axios
// Base URL: usa VITE_API_URL se definida; caso contrário, usa /api no mesmo host (funciona com proxy em dev e em produção)
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptador de requisição - adicionar token
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptador de resposta - tratar erros
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Se o token expirou ou é inválido
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      
      // Só redirecionar se não estiver já na página de login
      if (currentPath !== '/login' && currentPath !== '/forgot-password' && currentPath !== '/reset-password') {
        Cookies.remove('token');
        toast.error('Sessão expirada. Faça login novamente.');
        window.location.href = '/login';
      }
    }
    
    const skipGlobalErrorToast = error.config?.skipGlobalErrorToast;

    // Erro de servidor
    if (!skipGlobalErrorToast && error.response?.status >= 500) {
      toast.error('Erro interno do servidor. Tente novamente mais tarde.');
    }
    
    // Erro de rede
    if (!skipGlobalErrorToast && (error.code === 'NETWORK_ERROR' || error.message === 'Network Error')) {
      toast.error('Erro de conexão. Verifique sua internet.');
    }
    
    // Timeout
    if (!skipGlobalErrorToast && error.code === 'ECONNABORTED') {
      toast.error('Tempo limite excedido. Tente novamente.');
    }

    return Promise.reject(error);
  }
);

export default api;
